import * as React from "react";
import DatePicker from "react-datepicker";
import PrimaForm from "../PrimaForm";

var ExtensionForm = function ExtensionForm(props) {
  var _polizaEndorsementFor;

  var poliza = props.poliza,
      polizaEndorsementForm = props.polizaEndorsementForm,
      onChangeDuration = props.onChangeDuration,
      onChangeAmount = props.onChangeAmount;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-6"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Inicio vigencia"), /*#__PURE__*/React.createElement(DatePicker, {
    className: "form-control",
    dateFormat: "dd-MM-yyyy",
    maxDate: poliza.finish_date,
    selected: poliza.start_date,
    disabled: true
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-md-6"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Fin vigencia"), /*#__PURE__*/React.createElement(DatePicker, {
    className: "form-control",
    dateFormat: "dd-MM-yyyy",
    minDate: poliza.start_date,
    selected: polizaEndorsementForm === null || polizaEndorsementForm === void 0 ? void 0 : (_polizaEndorsementFor = polizaEndorsementForm.poliza_params) === null || _polizaEndorsementFor === void 0 ? void 0 : _polizaEndorsementFor.finish_date,
    onChange: function onChange(item) {
      onChangeDuration({
        finish_date: item
      });
    }
  }))), /*#__PURE__*/React.createElement(PrimaForm, {
    canModify: true,
    poliza: poliza,
    polizaEndorsementForm: polizaEndorsementForm,
    onChangeAmount: onChangeAmount
  }));
};

export default ExtensionForm;